import Accordion from "@/common/components/Accordion";
import { EstablishmentCompanyData } from "@/common/types/establishment/company.type";
import UpdateEstablishmentCaModule from "./UpdateEstablishmentCaModule";
import Select from "@/common/components/Select";
import TextField from "@/common/components/TextField";
import { formatPercentage } from "@/common/utils/formatters";

interface AccreditationCASectionProps {
  establishmentCompany: EstablishmentCompanyData;
  disabled?: boolean;
}

const AccreditationCASection = ({
  establishmentCompany,
  disabled,
}: AccreditationCASectionProps) => {
  return (
    <Accordion
      className="p-0"
      triggerClassName="p-4"
      bodyClassName="p-4 pt-0"
      defaultOpen
      head={(
        <div className="flex items-center gap-3">
          <div onClick={(event) => {
            event.stopPropagation();
          }}>
            <UpdateEstablishmentCaModule
              establishmentCompany={establishmentCompany}
              disabled={disabled}
            />
          </div>

          <p className="text-lg font-bold">
            Dados para abastecimento (CA)
          </p>
        </div>
      )}
      body={(
        <div className="flex flex-col gap-4">
          <Select
            label="Meios de captura"
            placeholder
            value={establishmentCompany?.matrix_branch?.capture_methods?.map(({ capture_method }) => ({
              value: capture_method.id,
              label: capture_method.display_name,
            }))}
            isMulti
            isDisabled
          />

          <Select
            label="Serviços permitidos para empresa"
            placeholder
            value={establishmentCompany?.company_product_categories?.map((category) => ({
              label: category.product_category.display_name,
              value: category.product_category.id,
            }))}
            isMulti
            isDisabled
          />

          <TextField
            label="Taxa diária de juros de adiantamento"
            value={establishmentCompany?.matrix_branch_payment_advance_daily_interest
              ? formatPercentage(Number(establishmentCompany.matrix_branch_payment_advance_daily_interest))
              : '--'}
            disabled
          />
        </div>
      )}
    />
  );
}

export default AccreditationCASection;
